import Image from 'app/Components/Shared/Image/image';
import React, {FC, CSSProperties} from 'react';
import {getBackgroundImageProps, getImageProps} from 'app/utilities/ImageProps';
import {ContentReferenceProperty, StringProperty} from '@episerver/spa-core/Property';
import IEpiserverContext from '@episerver/spa-core/Core/IEpiserverContext';

type BaseBlock = {
  title: StringProperty;
  subtitle: StringProperty;
  backgroundImage: ContentReferenceProperty;
  mobileBackgroundImage: ContentReferenceProperty;
};

type PageWrapperProps = {
  desktopLayout?: 'contents' | 'background';
  props: {
    data: Partial<BaseBlock>;
    context: IEpiserverContext;
  };
};

const PageWrapper: FC<PageWrapperProps> = ({props: {data, context}, children, desktopLayout = 'contents'}) => {
  const desktopBackground = getBackgroundImageProps(data.backgroundImage, context)?.style?.backgroundImage;
  const mobileBackground = getBackgroundImageProps(data.mobileBackgroundImage, context)?.style?.backgroundImage;
  const desktopImage = getImageProps(data.backgroundImage, context);

  const style = {
    '--mobile-background': mobileBackground ?? desktopBackground,
    '--desktop-background': desktopBackground,
  } as CSSProperties;

  return (
    <div className={`PageWrapper ${desktopLayout}`} style={style}>
      <div className='PageWrapper__wrapper'>
        <Image className='PageWrapper__image' {...desktopImage} />
        <div className='PageWrapper__head'>
          <h1 className='PageWrapper__title'>{data.title?.value}</h1>
          <h3 className='PageWrapper__subtitle'>{data.subtitle?.value}</h3>
        </div>
      </div>
      {children}
    </div>
  );
};

export default PageWrapper;
